<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputShippingOptions" });
import "tailwindcss/tailwind.css";
import { Span } from "../../../../typography/index.js";
export let options = [];
</script>

{#if options}
    <ul class = 's8-shipping-option-list'>
        {#each options as option }
            <li>
                <Span label = { `resource.auction.properties.shipping.options.${ option }.label` } />
                <Span
                    css = 'text-grey-600'
                    label = { `resource.auction.properties.shipping.options.${ option }.description.buyer` }
                />
            </li>
        {/each}
    </ul>
{/if}

<style>
    ul.s8-shipping-option-list {

    font-size: 0.75rem;

    line-height: 1rem
}

        ul.s8-shipping-option-list li {

    margin-bottom: 1rem;

    margin-left: 1rem;

    list-style-position: outside;

    list-style-type: disc
}</style>